import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-white/40 bg-white/70 backdrop-blur">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-3 px-4 py-6 text-sm text-slate-600 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <p className="text-center sm:text-left">
          &copy; {currentYear} EduSmart. Mọi quyền được bảo lưu.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-slate-500 sm:justify-end">
          <button className="transition hover:text-indigo-600">
            Điều khoản sử dụng
          </button>
          <button className="transition hover:text-indigo-600">
            Chính sách bảo mật
          </button>
          <a href="mailto:support@edusmart.vn" className="transition hover:text-indigo-600">
            Hỗ trợ khách hàng
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
